import { useEffect, useRef, useState } from 'react'
import {
  Box, Button, Flex,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuOptionGroup,
  MenuDivider,
  Portal,
  Text
} from '@chakra-ui/react';
import { optionTypes } from "../types/subWidgetOptionsTypes";
import LaunchdeckFormInput from '../../../../forms/TextInputField/components/LaunchdeckFormInput';
import { IoChevronDownOutline } from 'react-icons/io5';
import { isValidArray } from '../../../../global/helpers/global-helpers';


export const CtaButton = ({
  subWidgetId,
  editableItemId,
  setSubWidgetContent,
  subWidgetContent,
  isDragging,
  handleEditItemByClick,
  handleSaveItemByClickOutside,
  options,
  dsrId,
  dsrPages,
  altPageNames,
  pDsrId
}) => {
  const [ctaText, setCtaText] = useState("Button");
  const [ctaLink, setCtaLink] = useState("");
  const [internalLink, setInternalLink] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [chooseInternalLink, setChooseInternalLink] = useState(false);
  const [clickCount, setClickCount] = useState(0);

  const [chosenPageNameDisplay, setChosenPageNameDisplay] = useState("")
  const containerRef = useRef(null);

  const [customPagesArray, setCustomPagesArray] = useState(null)
  const [faqPageDisplayName, setFaqPageDisplayName] = useState(null)
  const [overviewPageDisplayName, setOverviewPageDisplayName] = useState(null)
  const [mapPageDisplayName, setMapPageDisplayName] = useState(null)
  const [sharedDocsPageDisplayName, setSharedDocsPageDisplayName] = useState(null)

  let buttonAlign = '0';
  let buttonVariant = options[optionTypes.VARIANT];

  switch (options[optionTypes.ALIGN]) {
    case 'left':
    default:
      buttonAlign = '-1'
      break;
    case 'center':
      buttonAlign = '0'
      break;
    case 'right':
      buttonAlign = '1'
      break;
  }



  useEffect(() => {
    if (subWidgetContent) {

      const externalLinkArray = subWidgetContent?.split('/?&/');
      const isExternalLink = externalLinkArray[1] ? true : false

      const internalLinkArray = subWidgetContent?.split('/?intl/');
      const isInternalLink = internalLinkArray[1] ? true : false

      const handlePageNameDisplay = (subpageType) => {
        let pageNameDisplay = "";

        switch (subpageType) {
          case ("overview"): {
            pageNameDisplay = overviewPageDisplayName
            break;
          }
          case ("updates"): {
            pageNameDisplay = "Updates"
            break;
          }
          case ("faq"): {
            pageNameDisplay = faqPageDisplayName
            break;
          }
          case ("map"): {
            pageNameDisplay = mapPageDisplayName
            break;
          }
          case ("shared-docs"): {
            pageNameDisplay = sharedDocsPageDisplayName
            break;
          }
          default: {
            const foundCustomPage = dsrPages?.filter(page => page.pageId === 'pg__' + subpageType)
            const { pageTitle } = foundCustomPage[0] || {}
            pageNameDisplay = pageTitle ? pageTitle : 'Custom page'

            break;
          }
        }

        pageNameDisplay && setChosenPageNameDisplay(pageNameDisplay)

      }


      if (isExternalLink) {
        setCtaText(externalLinkArray[0])
        setCtaLink(externalLinkArray[1])
        setInternalLink("")
      } else if (isInternalLink) {
        setCtaLink("")
        setCtaText(internalLinkArray[0])

        const scrubbedLink = internalLinkArray[1].startsWith("pg__") ? internalLinkArray[1].slice(4) : internalLinkArray[1]

        setInternalLink(scrubbedLink)
        setChooseInternalLink(true)

        const subpageType = scrubbedLink?.split('?')[0];

        handlePageNameDisplay(subpageType)
      }
    }
  }, [subWidgetContent, dsrPages, faqPageDisplayName, mapPageDisplayName, overviewPageDisplayName, sharedDocsPageDisplayName]);


  useEffect(() => {
    if (Array.isArray(dsrPages)) {
      const customPagesArray = dsrPages?.filter(page => page.pageType === "customised-page")
      setCustomPagesArray(customPagesArray)

      const overviewPage = dsrPages?.filter(page => page.pageType === "overview")[0]
      overviewPage && setOverviewPageDisplayName(overviewPage.pageTitle ? overviewPage.pageTitle.trim() : "Overview")
    }

    if (altPageNames) {
      const { map, sharedDocs, faq } = altPageNames || {};
      map && setMapPageDisplayName(map.trim() || "Mutual Action Plan")
      faq && setFaqPageDisplayName(faq.trim() || "Q&A")
      sharedDocs && setSharedDocsPageDisplayName(sharedDocs.trim() || "Shared Documents")
    }
  }, [dsrPages, altPageNames]);


  useEffect(() => {
    const newCtaContent = chooseInternalLink ? `${ctaText}/?intl/${internalLink}` : `${ctaText}/?&/${ctaLink}`;

    if (newCtaContent !== subWidgetContent) {
      setSubWidgetContent(newCtaContent)
    }
  }, [ctaText, ctaLink, chooseInternalLink, internalLink]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if ((isFocused && containerRef.current) && !containerRef?.current.contains(event.target)
        && !event.target.closest('.chakra-menu__menu-list')
      ) {
        setIsFocused(false);
        handleSaveItemByClickOutside();
      }
    };

    if (isFocused) {
      setTimeout(() => window.addEventListener('mousedown', handleClickOutside), 1)
    } else {
      window.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      window.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isFocused]);

  const handleClick = () => {
    if (!isDragging) {
      handleEditItemByClick()
      setIsFocused(true)
    }
  }

  const handlePickInternalPage = (pageId, subpage) => {

    let pageNameDisplay = "";
    let subpageUrlId = "";

    if (pageId && !subpage) {
      const foundCustomPage = dsrPages?.filter(page => page.pageId === pageId)
      const { pageTitle } = foundCustomPage[0] || {}

      pageTitle && setChosenPageNameDisplay(pageTitle)

      const scrubbedPageId = pageId.startsWith("pg__") ? pageId.slice(4) : pageId
      scrubbedPageId && setInternalLink(`${scrubbedPageId}?pageType=custom`)

    } else if (!pageId && subpage) {
      switch (subpage) {
        case ("overview"): {
          pageNameDisplay = overviewPageDisplayName
          subpageUrlId = "overview?pageType=essential"
          break;
        }
        case ("updates"): {
          pageNameDisplay = "Updates"
          subpageUrlId = "updates?pageType=essential"
          break;
        }
        case ("faq"): {
          pageNameDisplay = faqPageDisplayName
          subpageUrlId = "faq?pageType=custom"
          break;
        }
        case ("map"): {
          pageNameDisplay = mapPageDisplayName
          subpageUrlId = "map?pageType=essential"
          break;
        }
        case ("shared-docs"): {
          pageNameDisplay = sharedDocsPageDisplayName
          subpageUrlId = "shared-docs?pageType=essential"
          break;
        }
        default: {
          subpageUrlId = ""
          break;
        }
      }

      pageNameDisplay && setChosenPageNameDisplay(pageNameDisplay)
      subpageUrlId && dsrId && setInternalLink(`${subpageUrlId}`)

    } else {
      setCtaLink("")
    }
  }

  const handleChangeLinkType = () => {
    if (!!chooseInternalLink) {
      setChooseInternalLink(false)
    } else {
      setChooseInternalLink(true)
    }
    setCtaLink("")
    setClickCount(prevCount => prevCount + 1)
  }

  const renderInternalLinkDropdown = () => {
    const renderCustomPages = () => {
      if (isValidArray(customPagesArray)) {
        return customPagesArray?.map(page => {
          const { pageId, pageTitle } = page || {}
          if (pageId) {
            return (
              <MenuItem pl='2em' onClick={() => handlePickInternalPage(pageId, "")} fontSize='0.875em'>{pageTitle}</MenuItem>
            )
          } else return null
        })
      } else return null;
    }

    return (
      <Menu closeOnSelect={true} w='100%'>
        <MenuButton w='100%'>
          <Flex position='relative' w='100%' bg='white' border='1px solid' borderColor='gray.200' rounded='0.25em' p='0.4em 1em' justify='space-between' align='center'>
            <Box position='absolute' color='gray.500' fontSize='0.75em' bottom='2.2em' bg='white'>Internal Link</Box>
            <Flex w='100%' fontSize='0.875em'> {chosenPageNameDisplay ? chosenPageNameDisplay : "Pick a page"}</Flex>
            <Box as={IoChevronDownOutline} fontSize='0.875em' />
          </Flex>
        </MenuButton>
        <Portal>
          {pDsrId ?
            <MenuList minWidth='240px' zIndex='5000'>
                   <MenuOptionGroup title='Your pages' fontSize='0.75em' color='brand.500'>
              {renderCustomPages()}
              </MenuOptionGroup>
            </MenuList>
            :
            <MenuList minWidth='240px' zIndex='5000'>

              <MenuOptionGroup title='Essential pages' fontSize='0.75em' color='brandPink.500'>
                <MenuItem pl='2em' onClick={() => handlePickInternalPage("", "overview")} fontSize='0.875em'>{overviewPageDisplayName}</MenuItem>
                <MenuItem pl='2em' onClick={() => handlePickInternalPage("", "updates")} fontSize='0.875em'>Updates</MenuItem>
                <MenuItem pl='2em' onClick={() => handlePickInternalPage("", "faq")} fontSize='0.875em'>{faqPageDisplayName}</MenuItem>
                <MenuItem pl='2em' onClick={() => handlePickInternalPage("", "map")} fontSize='0.875em'>{mapPageDisplayName}</MenuItem>
                <MenuItem pl='2em' onClick={() => handlePickInternalPage("", "shared-docs")} fontSize='0.875em'>{sharedDocsPageDisplayName}</MenuItem>
              </MenuOptionGroup>
              <MenuDivider />
              <MenuOptionGroup title='Your pages' fontSize='0.75em' color='brand.500'>
                {renderCustomPages()}
              </MenuOptionGroup>
            </MenuList>
          }
        </Portal>
      </Menu>
    )
  }

  return (
    editableItemId === subWidgetId
      ?
      <Flex ref={containerRef} direction='column' gap='1em' width="100%" p='2em 1em' minH='14em'>
        <Box pl='0.5em' pb='0.5em'>
          <Box>
            <Box fontSize='0.7em' fontWeight='700' color='brandDark.500'>MANAGE BUTTON</Box>
            <Text cursor='pointer' fontSize='0.7em' color='gray.500' onClick={() => handleChangeLinkType()}> {chooseInternalLink ? "Redirect to an external page > " : "Link to an internal page > "} </Text>
          </Box>
        </Box>

        <LaunchdeckFormInput
          onChange={(e) => setCtaText(e.target.value)}
          value={ctaText}
          label="Button text"
          labelFontSize='0.875em'
        />

        {chooseInternalLink ?
          <Box key={clickCount} w='100%' className='fade-in'>
            {renderInternalLinkDropdown()}
          </Box>

          :
          <Box key={clickCount} className='fade-in'>
            <LaunchdeckFormInput
              onChange={(e) => setCtaLink(e.target.value)}
              name="button-external-link-url"
              value={ctaLink}
              label="External link"
              labelFontSize='0.875em'
            />
          </Box>
        }


      </Flex>
      : <Box
        display='grid'
        gridTemplateColumns={'1fr 1fr 1fr'}
        justifyContent='center'
        alignItems='center'
        width='100%'
        height='100%'
        padding="10px"
      >
        <Box
          width='100%'
          height='100%'
          onClick={handleClick}
        ></Box>

        <Box
          order={Number(buttonAlign)}
          display='flex'
          justifyContent={options[optionTypes.ALIGN]}
          alignItems='center' width='100%'
        >
          <Button
            onClick={() => handleClick()}
            bg={buttonVariant === 'primary' ? 'brandDark.500' : '#EAF4FD'}
            fontSize='0.875em'
            rounded='0.85em'
            px='5em'
            height="50px"
            color={buttonVariant === 'primary' ? 'white' : '#3295EC'}
            _hover={{ color: "brandDark.500", bg: "gray.200" }}
          >
            {ctaText}
          </Button>
        </Box>

        <Box
          width='100%'
          height='100%'
          onClick={handleClick}
        ></Box>
      </Box>
  )
}
